export const getSortDetail = state => state.sort.sortDetail;
export const getAllSort = state => state.sort.allSorts;
